import React, { Component } from 'react'
import { StyleModal } from './style'
import { Button } from '../..'
import { COLOR } from '../../../themes'
import { MODAL_RESETPASSWORD, MODAL_STATUS } from '../../../helpers'

export class ModalResetPassword extends Component {

  constructor(props) {
    super(props)
    this.state = {
      email : '',
      errorEmail: '',
      sendEmail: false
    }
  }

  inputEmail = (event) => {
    this.setState({
      email: event.target.value,
      errorEmail: '',
    })
  }

  checkInvalid = () => {
    const { email } = this.state
    const {
      language = 'EN'
    } = this.props
    if(email === '') {
      this.setState({
        errorEmail: MODAL_RESETPASSWORD.ENTER_VALID_EMAIL[language]
      })
    }
    else
    {
      /* eslint-disable */
      let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if(reg.test(email) === false){
        this.setState({
          errorEmail: MODAL_RESETPASSWORD.EMAIL_WRONG_FORMAT[language]
        })
      }else{
        const { resetPasswordSendEmailUser } = this.props;
        resetPasswordSendEmailUser(email,()=>{
          this.setState({
            sendEmail: true
          })
        })
      }
    }
  }

  closeModal = () => {
    const { onClickBack } = this.props;
    this.setState({ sendEmail: false })
    onClickBack();
  }

  render() {
    const {
      email,
      errorEmail,
      sendEmail
    } = this.state
    const { language = 'EN', colorTheme } = this.props

    return (
      <StyleModal colorTheme={colorTheme}>
        <div className='div-Modal' onClick={this.closeModal} />
        <div className='content-Modal'>
          <div className='sub-content'>
            <div className='head-modal'>
              { sendEmail ? MODAL_RESETPASSWORD.SENT_EMAIL[language] : MODAL_RESETPASSWORD.TITLE[language]}
            </div>
            {
              sendEmail
              ?
                <div>
                  <div className='description'>
                    {MODAL_RESETPASSWORD.EMAIL_SEND[language]}
                  </div>
                  <div className='description-email'>
                    {email}
                  </div>
                  <div className='description'>
                    {MODAL_RESETPASSWORD.CHECK_INBOX[language]}
                  </div>
                </div>
              :
              <div className='description'>
                {MODAL_RESETPASSWORD.SUBTITLE[language]}
              </div>
            }

            {
              !sendEmail &&
              <div>
                <input
                  value={email}
                  onChange={(e) => this.inputEmail(e)}
                  placeholder={MODAL_RESETPASSWORD.EMAIL[language]}
                  className='input-email'
                  style={
                    errorEmail !== ''
                    ? { color: COLOR.RED_2, borderBottom: `1px solid ${COLOR.RED_2}` }
                    : { color: COLOR.BLACK_1, borderBottom: `1px solid ${COLOR.BLACK_1}` }
                  }
                />

                <div className='text-error'>
                  {errorEmail}
                </div>
              </div>
            }

            <div className='tabel btn-modal'>
              <div className='table-row'>
                {
                  sendEmail
                  ?
                    <div>
                      <div className='table-cell'>
                        <Button
                          name={MODAL_RESETPASSWORD.DONE[language]}
                          onClick={this.closeModal}
                          className='modal-btn-done'
                        />
                      </div>
                    </div>
                  :
                    <div>
                      <div className='table-cell tabel-right'>
                        <Button
                          name={MODAL_STATUS.BACK[language]}
                          onClick={this.closeModal}
                          className='modal-btn-back'
                        />
                      </div>

                      <div className='table-cell tabel-left'>
                        <Button
                          name={MODAL_RESETPASSWORD.SEND[language]}
                          disabled={email === '' ? true : false}
                          onClick={this.checkInvalid}
                          className={`modal-btn-send ${email !== '' ? 'is-pass':''}`}
                        />
                      </div>
                    </div>
                }

              </div>
            </div>
          </div>
        </div>
      </StyleModal>
    )
  }
}
